import React, { useState, useEffect } from 'react';
import { Table, Input, Button, Row, Col } from 'antd';
import dayjs from 'dayjs';
import { getCrewAssignment } from '../../services/crew';



const Summary = ({ basicDetails = {}, employees = [], assignDate, onPrev, onSave }) => {
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setTableData(
      (employees || []).map(emp => ({
        ...emp,
        scheduleIn: emp.scheduleIn || (basicDetails.startTime && dayjs.isDayjs(basicDetails.startTime) ? basicDetails.startTime.format('HH:mm') : basicDetails.startTime || ''),
        scheduleOut: emp.scheduleOut || (basicDetails.endTime && dayjs.isDayjs(basicDetails.endTime) ? basicDetails.endTime.format('HH:mm') : basicDetails.endTime || ''),
      }))
    );
  }, [employees, basicDetails]);

  const handleCellChange = (key, dataIndex, value) => {
    setTableData(prev =>
      prev.map(row =>
        row.key === key ? { ...row, [dataIndex]: value } : row
      )
    );
    };
    
    useEffect(() => {
        fetchCrewAll();
      }, []);    
        const fetchCrewAll = async () => {
            try {
                const response = await getCrewAssignment();
              
              
              
            } catch (error) {
              console.error('Error fetching crew templates:', error);
            }
          };

  const columns = [
    { title: 'Sl. no.', dataIndex: 'key', key: 'key', width: 70 },
    { title: 'Employee Name', dataIndex: 'name', key: 'name', width: 150 },
    { title: 'Employee ID', dataIndex: 'id', key: 'id', width: 120 },
    {
      title: 'Schedule In',
      dataIndex: 'scheduleIn',
      key: 'scheduleIn',
      width: 100,
      render: (text, record) => (
        <Input
          value={text}
          style={{ width: 70, textAlign: 'center', padding: 2 }}
          onChange={e => handleCellChange(record.key, 'scheduleIn', e.target.value)}
        />
      ),
    },
    {
      title: 'Schedule Out',
      dataIndex: 'scheduleOut',
      key: 'scheduleOut',
      width: 100,
      render: (text, record) => (
        <Input
          value={text}
          style={{ width: 70, textAlign: 'center', padding: 2 }}
          onChange={e => handleCellChange(record.key, 'scheduleOut', e.target.value)}
        />
      ),
    },
    { title: 'Union', dataIndex: 'union', key: 'union', width: 120 },
    { title: 'SSN4', dataIndex: 'ssn4', key: 'ssn4', width: 100 },
    { title: 'Task', dataIndex: 'task', key: 'task', width: 120 },
  ];

  // Format start/end time for display
  const formatTime = t =>
    t && dayjs.isDayjs(t) ? t.format('HH:mm') : (typeof t === 'string' ? t : '');

  // Format assign date
  const formatDate = d =>
    d && dayjs.isDayjs(d) ? d.format('DD-MM-YYYY') : (typeof d === 'string' ? d : '');

  return (
    <div className="crew-summary-container">
      <h2 className="summary-title">Basic Details</h2>
      <div className="summary-grid">
        {/* Crew & Supervision */}
        <div className="summary-section">
          <div className="summary-section-header">
            <span role="img" aria-label="crew">&#128101;</span> Crew & Supervision
          </div>
          <div className="summary-row">
            <span className="summary-key">Crew Name</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.crewName}</span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Crew Lead</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.crewLead}</span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Supervisor</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.supervisor}</span>
          </div>
        </div>
        {/* Shift Timing */}
        <div className="summary-section">
          <div className="summary-section-header">
            <span role="img" aria-label="clock">&#128337;</span> Shift Timing
          </div>
          <div className="summary-row">
            <span className="summary-key">Start Time</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{formatTime(basicDetails?.startTime)}</span>
          </div>
          <div className="summary-row">
            <span className="summary-key">End Time</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{formatTime(basicDetails?.endTime)}</span>
          </div>
        </div>
        {/* Work details */}
        <div className="summary-section">
          <div className="summary-section-header">
            <span role="img" aria-label="work">&#128295;</span> Work details
          </div>
          <div className="summary-row">
            <span className="summary-key">Task</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.task}</span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Premium</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.premium}</span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Event</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.eventName}</span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Event description</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.eventDescription}</span>
          </div>
        </div>
        {/* Location & Compensation */}
        <div className="summary-section">
          <div className="summary-section-header">
            <span role="img" aria-label="location">&#128205;</span> Location & Compensation
          </div>
          <div className="summary-row">
            <span className="summary-key">Venue</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.venue}</span>
          </div>
          <div className="summary-row">
            <span className="summary-key">Pay Scale</span>
            <span className="summary-divider"></span>
            <span className="summary-value">{basicDetails?.payScale}</span>
          </div>
        </div>
      </div>
      <div className="assigned-employees-header">
        <span>
          Assigned Employees
          {assignDate ? ` • ${formatDate(assignDate)}` : ''}
        </span>
      </div>
      <Table
        columns={columns}
        dataSource={tableData}
        pagination={false}
        scroll={{ x: 'max-content' }}
        bordered
        className="crew-summary-table"
      />
      <Row justify="end" style={{ marginTop: 24 }}>
        <Col>
          <Button style={{ marginRight: 8 }} onClick={onPrev}>
            Previous
          </Button>
        </Col>
        <Col>
          <Button type="primary" onClick={() => onSave(tableData)}>
            Save
          </Button>
        </Col>
      </Row>

      <style>{`
        .crew-summary-container {
          font-family: 'Segoe UI', Arial, sans-serif;
          background: #fff;
          padding: 24px;
        }
        .summary-title {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 12px;
        }
        .summary-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
          margin-bottom: 24px;
        }
        .summary-section {
          background: #eaf2ff;
          border-radius: 12px;
          padding: 0 0 12px 0;
          margin-bottom: 0;
          box-shadow: 0 1px 2px rgba(0,0,0,0.03);
        }
        .summary-section-header {
          background: #dbeafe;
          font-weight: 500;
          padding: 8px 12px;
          border-radius: 12px 12px 0 0;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          font-size: 15px;
        }
        .summary-row {
          display: flex;
          align-items: center;
          background: #f8fafc;
          padding: 4px 12px;
          font-size: 14px;
          border-bottom: 1px solid #f0f0f0;
        }
        .summary-row:last-child {
          border-bottom: none;
        }
        .summary-key {
          flex: 1;
          color: #222;
        //   background: #B4B4B450;
        }
        .summary-divider {
          width: 1px;
          height: 20px;
          background: #dbeafe;
          margin: 0 12px;
        }
        .summary-value {
          flex: 1;
          text-align: right;
          color: #222;
        }
        .assigned-employees-header {
          font-size: 16px;
          font-weight: 500;
          margin: 32px 0 12px 0;
        }
        .crew-summary-table .ant-table-thead > tr > th {
          background: #f5f7fa;
          font-weight: 500;
        }
        .crew-summary-table .ant-table-cell {
          font-size: 14px;
        }
        .crew-summary-table .ant-table-tbody > tr > td {
          padding: 6px 8px;
        }
      `}</style>
    </div>
  );
};

export default Summary;
